/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'scourge',
    quality: 0,
    mana: -1,
    strength: -1
}